import React, {Context, createContext, useRef, useState} from 'react';
import './NavigationFooter.css'
import {active, profile, home, inactive, tasks, wallet} from "./NavigationIcons";

export let SetRootNavbarOn : Context<(b: boolean) => void>
export let SubscribeToSelection : Context<(f: (screen: number) => void) => void>


export type NavigationFooterProps = {
    selected: number
    setSelected: (arg: number) => void
}


export function NavigationFooter({props}: { props: NavigationFooterProps }) {
    const [isNavbarVisible, setIsNavbarVisible] = useState(true)
    const onSelectedFunctions = useRef([] as ((screen : number) => void)[])

    const setSelectedConst = (n: number) => {
        return () => {
            for (let onSelectedFunction of onSelectedFunctions.current) { onSelectedFunction(n) }
            props.setSelected(n);
        }
    }

    SetRootNavbarOn = createContext((b) => setIsNavbarVisible(b))
    SubscribeToSelection = createContext((v) => {
        onSelectedFunctions.current.push(v)
    })

    const className = isNavbarVisible
        ? "mini-app-navigation bg-black"
        : "mini-app-navigation mini-app-navigation-hidden click-through"

    const navButtonStyle = isNavbarVisible ? {} : {height: 0, width: 0}

    const createNavButton = (index : number, icon : (color : string) => JSX.Element) => {
        return <div className="flex-center " style={{height: isNavbarVisible ? "4rem" : "4rem", transition: "0.2s"}}>
            <button onClick={setSelectedConst(index)} className="nav-button" style={navButtonStyle}>
                {icon(props.selected === index ? active : inactive)}
            </button>
        </div>
    }

    return (
        <div className={className} style={{height: "4rem"}}>
            <div className="navigation-buttons full-high">
                {createNavButton(0, profile)}
                {createNavButton(1, home)}
                {createNavButton(2, wallet)}
                {createNavButton(3, tasks)}
            </div>
        </div>
    );
}